import * as React from "react"
import * as _ from "lodash"
import IFoodCategory from "../../models/IFoodCategory"
import {LOADING_STATE} from "../../utils/AppUtils"
import {FoodGroupsEditorProps} from "../../components/patient/edit/FoodGroupsEditor"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard";
import IFoodGroup from "../../models/IFoodGroup";

/*
 * created by aditya on 18/7/2018
 */

export interface FoodGroupEditViewContProps {
    foodGroupDistribution: IFoodGroup[],
    staticFoodGroups: IFoodCategory[],
    displayMode: EditViewDisplayMode,
    updateMealSlots?: (calorieDistribution: IFoodGroup[]) => void;
}

export interface FoodGroupEditViewContState {
    updatedFoodGroupDistribution: {item: IFoodGroup}[],
    isPatientMealSlotsDataLoaded: LOADING_STATE
}

class FoodGroupEditViewCont extends React.Component<FoodGroupEditViewContProps, FoodGroupEditViewContState> {
    constructor(props: FoodGroupEditViewContProps) {
        super(props);
        this.state = this.getStateFromProps(props);
    }
    componentWillReceiveProps(props: FoodGroupEditViewContProps) {
        this.setState(this.getStateFromProps(props));
    }
    getStateFromProps = (props: FoodGroupEditViewContProps) => {
        let currState: FoodGroupEditViewContState = {
            updatedFoodGroupDistribution: [],
            isPatientMealSlotsDataLoaded: LOADING_STATE.NOT_INITIALIZED
        }
        if ( !_.isNull(props.foodGroupDistribution) ) {
            _.map(props.foodGroupDistribution, function(meal){
                let clonePatientMealSlot = Object.assign([], meal)
                currState.updatedFoodGroupDistribution.push({item: clonePatientMealSlot})
            })
            currState.isPatientMealSlotsDataLoaded = LOADING_STATE.LOADED;
        }
        return currState;
    }
    getMealBuilderEditViewTemplateProps = () => {
        let patientMealBuilderViewProps: FoodGroupsEditorProps = {
            staticFoodGroups: this.props.staticFoodGroups,
            updatedFoodGroups: this.state.updatedFoodGroupDistribution,
            updateFoodGroupDistribution: this.updatePatientFoodGroupDistribution
        }
        let patientMealBuilderEditorProps: FoodGroupsEditorProps = {
            staticFoodGroups: this.props.staticFoodGroups,
            updatedFoodGroups: this.state.updatedFoodGroupDistribution,
            updateFoodGroupDistribution: this.updatePatientFoodGroupDistribution
        }
        return {"view": patientMealBuilderViewProps, "edit": patientMealBuilderEditorProps};
    }
    updatePatientFoodGroupDistribution = (updatedFoodGroups: {item: IFoodGroup}[]) => {
        this.setState({updatedFoodGroupDistribution: updatedFoodGroups}, () => {
            let updatedCalorieDistribution = this.getSaveObject();
            this.props.updateMealSlots(updatedCalorieDistribution);
        });
    }
    savePatientMealSlots = () => {
        let myInstance = this;
        let saveMealSlots: IFoodGroup[] = this.getSaveObject();

        if (saveMealSlots.length > 0) {
            this.setState({isPatientMealSlotsDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            /*this.props.savePatientMealSlots(this.props.patientId, saveDiagnosis).then(function(){
                myInstance.setState({isPatientDiagnosisDataLoaded: LOADING_STATE.LOADED})
            });*/
        }
    }
    getSaveObject = (): IFoodGroup[] => {
        let saveMealSlotsList: IFoodGroup[] = []
        _.map(this.state.updatedFoodGroupDistribution, function(updatedFoodGroupDistribution: {item: IFoodGroup}){
            saveMealSlotsList.push(updatedFoodGroupDistribution.item)
        })
        return saveMealSlotsList;
    }
    cancelActionHandler = () => {
        this.setState({updatedFoodGroupDistribution: this.getUpdatedMealSlotsFromProps(this.props)});
    }
    getUpdatedMealSlotsFromProps = (props: FoodGroupEditViewContProps): {item: IFoodGroup}[] => {
        let currUpdatedMealSlots: {item: IFoodGroup}[] = [];
        _.map(props.foodGroupDistribution, function(mealSlot){
            let clonePatientMealSlots = Object.assign({}, mealSlot);
            currUpdatedMealSlots.push({item: clonePatientMealSlots});
        });
        return currUpdatedMealSlots;
    }
    render() {
        return (
            <div className={"food-groups-edit-view-container"}>
                <EditViewCard cardTitleDisplay={""} templateName={"foodGroups"}
                              templateProps={this.getMealBuilderEditViewTemplateProps()}
                              lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientMealSlots}
                              cancelActionHandler={this.cancelActionHandler} displayMode={this.props.displayMode} />
            </div>
        )
    }
}

export default FoodGroupEditViewCont;